/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} autoVeloSiteCallForAMethodParams
* @property {string} api_owner - The API owner (company)
* @property {string} entity_name - The FQDN of the entity
* @property {string} environment - The type of development - front-end \ back-end
* @property {string} failure_reason - The reason for the failure, can be empty
* @property {string} http_code - The http code for this call - 200\404\..
* @property {string} method_name - The name of the method that was in use
* @property {string} module_name - The module name of the entity - edm name
* @property {string} msid - The msid of the site that made the call
* @property {string} service_name - The name of the service of the method
**/
/**
 * Name: Auto Velo - Site call for a Method. Evid: 401.
 * Event description: The event is sent when the server gets a call for a method, from a site.

 * api_owner - Type: string. Desc: The API owner (company)
 *
 * entity_name - Type: string. Desc: The FQDN of the entity
 *
 * environment - Type: string. Desc: The type of development - front-end \ back-end
 *
 * failure_reason - Type: string. Desc: The reason for the failure, can be empty
 *
 * http_code - Type: string. Desc: The http code for this call - 200\404\..
 *
 * method_name - Type: string. Desc: The name of the method that was in use
 *
 * module_name - Type: string. Desc: The module name of the entity - edm name
 *
 * msid - Type: string. Desc: The msid of the site that made the call
 *
 * service_name - Type: string. Desc: The name of the service of the method
 * @param {autoVeloSiteCallForAMethodParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var autoVeloSiteCallForAMethod = function (params) {
    return { evid: 401, src: 155, endpoint: 'auto-velo', params: params };
};
//# sourceMappingURL=index.js.map